const capitalizeFirstLetter = (value: string) => {
  if (!value) {
    return '';
  }

  const lowerCaseValue = value.toLowerCase();
  return lowerCaseValue.charAt(0).toUpperCase() + lowerCaseValue.slice(1);
};

const capitalizeFirstLetters = (sentence: string) =>
  sentence.split(' ').map(capitalizeFirstLetter).join(' ');

export { capitalizeFirstLetter, capitalizeFirstLetters };
